import { useEffect, useState } from "react"
import { getOperationsCount } from "../../../api/client"

export function useLandingPage() {
  const [totalOperations, setTotalOperations] = useState<number | null>(null)

  useEffect(() => {
    let isCurrent = true

    // Best-effort: a failed fetch just leaves the stat card showing its default placeholder.
    getOperationsCount()
      .then((response) => {
        if (isCurrent) {
          setTotalOperations(response.total)
        }
      })
      .catch(() => {})

    return () => {
      isCurrent = false
    }
  }, [])

  return { totalOperations }
}
